import { LatestTermsOfUse } from 'types/latest-terms-of-use';
import { createSelector } from 'reselect';
import { AppState } from 'pages/app/state';
import { Guid } from 'types/guid';

export const optelTermsSelector = (state: AppState) => state.terms.optelTerms;
export const nmvsTermsSelector = (state: AppState) => state.terms.nmvsTerms;

export const getOptelTerms = createSelector(
  [optelTermsSelector],
  (terms: LatestTermsOfUse) => terms
);

export const isOptelTermsAccepted = createSelector(
  [optelTermsSelector],
  (optelTerms: LatestTermsOfUse) => optelTerms.isAccepted
);

export const isOptelTermsId = (state: AppState, id: Guid) => createSelector(
  [optelTermsSelector],
  (optelTerms: LatestTermsOfUse) => optelTerms.id === id
)(state);

export const isNmvsTermsId = (state: AppState, id: Guid) => createSelector(
  [nmvsTermsSelector],
  (nmvoTerms: LatestTermsOfUse) => nmvoTerms.id === id
)(state);

export const getNmvsTerms = createSelector(
  [nmvsTermsSelector],
  (terms: LatestTermsOfUse) => terms
);

export const areAllTermsAccepted = createSelector(
  [optelTermsSelector, nmvsTermsSelector],
  (optelTerms: LatestTermsOfUse, nmvsTerms: LatestTermsOfUse) => (optelTerms == null || optelTerms.isAccepted) && 
                                                                (nmvsTerms == null || nmvsTerms.isAccepted)
);


// WEBPACK FOOTER //
// ./src/pages/terms-of-use/selectors.ts